export default __webpack_public_path__ + "static/media/kz.306106af.jpg";